module.exports = __webpack_public_path__ + "img/icon-result-success.166c397f.png";